import { Navigate } from "react-router-dom";
import { useUserStore } from "entities/user";
import { JSX } from "react";

type Props = {
    children: JSX.Element;
    redirectTo?: string; // по умолчанию "/"
};

export const AdminRedirect = ({ children, redirectTo = "/" }: Props) => {
  const iAmAdmin = useUserStore(s => s.iAmAdmin);

    if (!iAmAdmin) {
        return <Navigate to={redirectTo} replace />;
    }

    return children;
};
